import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { useInterval } from 'usehooks-ts';

import { useAcceptInviteToFriendsGroupMutation } from '@/api/queries/group';
import { H1, H3 } from '@/components/Typography/Typography';
import { removeChangeGroup } from '@/redux/reducers/userReducer';
import { type RootState, useAppDispatch } from '@/redux/store';

import chevronIcon from '/img/icons/chevron-right-gold.svg';
import handshake from '/img/icons/handshake.png';

const ChangeGroup: React.FC = () => {
  const [acceptInviteToFriendsGroup] = useAcceptInviteToFriendsGroupMutation();
  const { t } = useTranslation();
  const changeGroup = useSelector(
    (state: RootState) => state.user.user?.changeGroup,
  );
  const [activeChevronIndex, setActiveChevronIndex] = useState(0);

  const dispatch = useAppDispatch();

  useInterval(() => {
    setActiveChevronIndex((state) => (state === 2 ? 0 : state + 1));
  }, 500);

  return (
    <div className="changeGroup">
      <div className="changeGroup-title">
        <H1>{t('Switching groups')}</H1>
        <p>
          {t('You’re already in a group, but that’s okay; they’ll forgive you')}
        </p>
      </div>
      <div className="changeGroup-info">
        <div className="changeGroup-group">
          <img src={handshake} alt="handshake" />
          <H3>{changeGroup?.currentGroup?.groupName}</H3>
          <p>
            <span>{changeGroup?.currentGroup?.friendsCount}</span>{' '}
            {t('Friends')}
          </p>
        </div>
        <div className="changeGroup-arrows">
          {Array.from({ length: 3 }).map((_, index) => (
            <img
              key={index}
              className={cn(
                'transition-all',
                !(activeChevronIndex === index) && 'opacity-30',
              )}
              width={10}
              height={18}
              src={chevronIcon}
              alt="chevron"
            />
          ))}
        </div>
        <div className="changeGroup-group">
          <img src={handshake} alt="handshake" />
          <H3>{changeGroup?.newGroup?.groupName}</H3>
          <p>
            <span>{changeGroup?.newGroup?.friendsCount}</span> {t('Friends')}
          </p>
        </div>
      </div>
      <div className="changeGroup-buttons">
        <button
          type="button"
          className="btn btn-dark"
          onClick={() => dispatch(removeChangeGroup())}
        >
          {t('Stay in the group')}
        </button>
        <button
          type="button"
          className="btn"
          onClick={() => {
            dispatch(removeChangeGroup());
            acceptInviteToFriendsGroup({
              uniqueGroupKey: changeGroup?.newGroup?.uniqueGroupKey as string,
            });
          }}
        >
          {t('Join a new group')}
        </button>
      </div>
    </div>
  );
};

export default ChangeGroup;
